import React from "react";
import { QRCodeCanvas } from "qrcode.react";

const modalStyle = {
  overlay: {
    position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000
  },
  modal: {
    background: "#fff", padding: "2rem", borderRadius: "8px", textAlign: "center"
  }
};

const QRCodeModal = ({ open, onClose, url }) => {
  if (!open) return null;
  return (
    <div style={modalStyle.overlay}>
      <div style={modalStyle.modal}>
        <h3>📷 Scan to Share</h3>
        <QRCodeCanvas value={url} size={180} />
        <p style={{ marginTop: "1rem", fontSize: "0.9rem", wordBreak: "break-all" }}>{url}</p>
        <button onClick={onClose} style={{ marginTop: "1rem" }}>Close</button>
      </div>
    </div>
  );
};

export default QRCodeModal;
